function Dashboard() {
  return (
    <div className="container">
      <h1 className="page-title">Dashboard</h1>
      <p>Bienvenue dans le système MakerLab.</p>
    </div>
  );
}

export default Dashboard;